<div class="wrapper">
  @for (toggle of getToggleButtons(); track $index) {
    <div class="state-toggle">
      <mat-slide-toggle
        [ngModel]="getToggleValue(toggle.key)"
        (change)="handleToggleChange($event.checked, toggle?.key)"
      >
      </mat-slide-toggle>
      <div class="label">
        {{ toggle.label }}
      </div>
    </div>
  }

  @for (action of recordTableActions; track $index) {
    @switch (action) {
      @case ('CREATE_ROW') {
        <div class="add-record-container">
          @if (!isAddingNewRecord) {
            <button
              mat-button
              class="add-record-button"
              (click)="toggleAddRecordState()"
            >
              Добавить
            </button>
          } @else {
            <button
              mat-button
              class="cancel-button"
              (click)="toggleAddRecordState()"
            >
              Отмена
            </button>
            <button
              mat-button
              class="save-button"
              [disabled]="!isNewRecordDataValid"
              (click)="handleSaveButtonClick()"
            >
              Сохранить
            </button>
          }
        </div>
      }
      @case ('ADD_COMPONENTS_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="handleCreateComponent()"
          >
            Добавить (форма)
          </button>
        </div>
      }
      @case ('ADD_TESTING_RESULT_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="handleCreateTestingResult()"
          >
            Добавить (форма)
          </button>
        </div>
      }
      @case ('ADD_PRODUCT_CARD_QUALITY_CONTROL_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="activateAddQualityControl()"
          >
            Добавить (форма)
          </button>
        </div>
      }
      @case ('ADD_RECORD_LIST_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="activateAddCooperationOffer()"
          >
            Добавить (форма)
          </button>
        </div>
      }
      @case ('ADD_TELEGRAM_ACCOUNT_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="activateAddTelegramAccount()"
          >
            Добавить аккаунт
          </button>
        </div>
      }
      @case ('ADD_USER_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="activateAddUser()"
          >
            Добавить (форма)
          </button>
        </div>
      }
      @case ('PRICE_LEVEL_CONFIG_CREATE_FORM') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="activeAddPriceLevelConfig()"
          >
            Добавить (форма)
          </button>
        </div>
      }
      @case ('CREATE_BLOGGER_GROUPS') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="handleCreateGroup()"
          >
            Прикрепить к группе
          </button>
        </div>
      }
      @case ('VIEW_BLOGGER_GROUPS') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="handleOpenBloggerGroups()"
          >
            Изменения групп
          </button>
        </div>
      }
      @case ('SEND_OFFERS') {
        <div class="add-record-container">
          <button
            mat-button
            class="add-record-button"
            (click)="handleSendMassOffers()"
          >
            Масс рассылка
          </button>
        </div>
      }
    }
  }

  @if (isZoomOptionsNeededForCurrentResourceType(resourceParams.key)) {
    <div class="zoom-options-container">
      <mat-select
        [(value)]="currentZoomOption"
        (selectionChange)="handleZoomSelectValueChange($event)"
        panelClass="zoom-options"
      >
        @for (zoomOption of zoomOptions; track $index) {
          <mat-option
            [value]="zoomOption"
            [style.font-size.px]="14"
          >
            {{ zoomOption }}%
          </mat-option>
        }
      </mat-select>
    </div>
  }

  <div class="buttons">
    @for (actionButton of actionButtons; track $index) {
      @if (recordTableActions.includes(actionButton.action)) {
        <button
          mat-icon-button
          class="action-button"
          [matTooltip]="actionButton.tooltip"
          (click)="handleActionSelect(actionButton.action)"
        >
          <mat-icon>{{ actionButton.icon }}</mat-icon>
        </button>
      }
    }

    @if (recordTableActions.includes('EXPAND_GROUP')) {
      <div class="toggle-group">
        @for (toggleGroupBtn of toggleGroupActionButtons; track $index) {
          <button
            mat-icon-button
            class="action-button"
            [matTooltip]="toggleGroupBtn.tooltip"
            (click)="handleActionSelect(toggleGroupBtn.action)"
          >
            <mat-icon>{{ toggleGroupBtn.icon }}</mat-icon>
          </button>
        }
      </div>
    }

    <button
      mat-icon-button
      class="action-button"
      (click)="refreshTableClick()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <input
    #searchInput
    matInput
    class="search-input"
    placeholder="Поиск"
    [(ngModel)]="searchValue"
    (blur)="changeSearchValue(searchValue)"
    (keyup.enter)="searchInput.blur()"
  >

  <div class="actions-wrapper">
    <app-action-dropdown-menu
      [actionsList]="recordTableActions"
      (actionSelected)="handleActionSelect($event)"
    />
  </div>
</div>
